import { generateUtilityClasses } from '../../utils';

export const actionBarSkeletonClasses = generateUtilityClasses('ActionBarSkeleton', [
  'root',
  'toolbar',
  'toolbarLeft',
  'toolbarRight',
  'filterButton',
  'actions',
  'settingButton',
  'refetchButton',
  'pagination',
]);
